<template lang="html">
	<div class="success-view">
		<div class="row">
			<div class="col text-center">
				<h4>Deine Bestellung wurde erfolgreich verarbeitet.</h4>
				<p>Du erhältst eine E-Mail als Bestätigung.</p>
				<div class="text-success">
					<check-icon />
				</div>
				<button 
					class="btn btn-primary" 
					@click="$emit('reset')">
					Neue Bestellung
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { CheckIcon } from 'vue-feather-icons'

export default {
	name: 'SuccessView',
	components: {
		CheckIcon
	}
}
</script>

<style lang="css">
.success-view  svg{
    height: 100px;
    width: 100px;
}
</style>
